import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {Button} from '../look';

const StyledButton = styled(Button).attrs({
  className: 'btn-secondary',
})`
  &&& {
    background: linear-gradient(to left, rgb(90, 18, 111) 0%, rgb(201, 0, 95) 100%);
    border: 0;
    width: 100%;
    margin-top: 30px;
    height: 40px;
    font-size: 15px;
    font-family: Segoe UI Bold, 'sans-serif';
    border-radius: 5px;
    color: white;
    }
`;

const LoginButton = props => {
  const {onClick, children, ...otherProps} = props;

  return (
    <StyledButton onClick={onClick} {...otherProps}>
      {children}
    </StyledButton>
  );
};

LoginButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
};

export default LoginButton;
